<template>
  <div class="menu-body-content">
    <!-- <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item v-for="(item, index) in menuItem" :index="item.name" :key="index">{{ item.title }}</el-menu-item>
    </el-menu> -->
    <ul class='menu-wrap'>
      <li @click='handleSelect(item.name)' :class="['normalMenu' , {'activeMenu': activeIndex == item.name} ]" v-for="(item, index) in menuItem" :index="item.name" :key="index">{{ item.title }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      activeIndex: 'home',
      menuItem: [
        { title: '首页', name: 'home' },
        { title: '工作动态', name: 'workDynamics' },
        { title: '标准征求意见', name: 'standardSolicitation' },
        { title: '标准查询', name: 'standardQuery' },
        { title: '产业服务', name: 'testEvaluation' },
        { title: '文档中心', name: 'documentCenter' },
        { title: '关于我们', name: 'aboutus' }
      ]
    }
  },
  watch: {
    $route: {
      handler(ne) {
        this.activeIndex = ne.name
      },
      immediate: true
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      if (key) {
        this.$router.push({ name: key })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.menu-body-content {
  margin: 0 auto;
  // width: $base-width;
  float: left;

  .menu-wrap {
    padding:20px;
    li{
      float: left;
    }
    .normalMenu {
      mix-blend-mode: normal;
      color: rgba(255, 255, 255, 1);
      font-size: 15px;
      line-height: 35px;
      margin: 0 12px;
      cursor: pointer;
    }
    .normalMenu:hover{
       color: rgba(255, 191, 112, 1)
    }
    .activeMenu {
      font-weight: 600;
      mix-blend-mode: normal;
      color: rgba(255, 191, 112, 1);
      font-size: 15px;
      line-height: 35px;
      border-bottom: 2px solid rgba(255, 191, 112, 1);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/menu.vue